// {Settings.tsx}

import { GetVersionsResponse } from 'quanterix-protos/data_management/v1/data_management_messages';
import { useEffect, useState } from 'react';
import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import * as DataMgrApi from '../api/DataManagementApi';
import { useTranslation } from 'react-i18next';
import { Button } from 'quil';
// import useStyles from './styles';
// import TEST_ID from './constants';

export interface SettingsProps {
  // Props
}

// export default function Settings({}: SettingsProps) {
export default function Settings() {
  const [versions, setVersions] = useState(GetVersionsResponse.fromPartial({}));
  const [showEula, setShowEula] = useState(false);
  const [eulaText, setEulaText] = useState('');
  const { t } = useTranslation(['common']);

  // const { classes, cx } = useStyles();
  useEffect(() => {
    const fetchVersions = async () => {
      const fetchedVersions = await DataMgrApi.GetVersions();
      setVersions(fetchedVersions);
    };

    fetchVersions();

    // Load EULA.md from Public folder
    const loadEula = async () => {
      const response = await fetch('/locales/en/eula.md');
      let md = await response.text();
      // MD → HTML conversion (headers, bold, paragraphs)
      let html = md
        .replace(/^# (.*$)/gim, '<h2>$1</h2>')
        .replace(/^## (.*$)/gim, '<h3>$1</h3>')
        .replace(/^### (.*$)/gim, '<h4>$1</h4>')
        .replace(/\*\*(.*?)\*\*/gim, '<b>$1</b>')
        .replace(/^-\s+/gm, '\u2022 ') // Unicode for bullet point
        .replace(/�/g, '\u201C') // Unicode for left double quote
        .replace(/�/g, '\u201D') // Unicode for right double quote
        .replace(/'/g, '\u2019'); // Unicode for right single quote (apostrophe)

      setEulaText(html);
    };

    loadEula();
    return () => {
      // Any cleanup code can go here
    };
  }, []);

  // Set suite version via API 
  const suiteVersion = versions?.additionalModuleVersions?.AnalysisSuite || undefined;

  return (
    <Stack>
      <Typography variant='h4' fontWeight="bold">{t("settingsPage.settings")}</Typography>
      <Box sx={{ height: '28px' }} />
      {suiteVersion &&
        <>
          <Typography variant="h5" fontWeight="bold">{t("settingsPage.about")}</Typography>
          <Divider flexItem />
          <Box sx={{ height: 6 }} />
          <Box width="500px">
            <Grid container columns={2}>
              <Grid item xs={1}>
                <Typography variant='h6'>{t("settingsPage.analysisSuiteVersion")}</Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography
                  variant="h6"
                  aria-label="analysis-suite-version"
                >
                  {suiteVersion}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        <Box sx={{ height: '24px' }} />
        </>

      }

      <Typography variant="h5" fontWeight="bold">{t("settingsPage.support")}</Typography>
      <Divider flexItem ></Divider>
      <Box sx={{ height: 6 }} />
      <Typography variant="h6">{t("settingsPage.contactInformation")}</Typography>
      <Typography>{t("settingsPage.customerSupportHours")}</Typography>
      <Box sx={{ height: '12px' }} />
      <Typography> {t("settingsPage.emailLabel")} <a href={`mailto:techsupport@quanterix.com')}`}>{t("settingsPage.emailID")}</a></Typography>
      <Typography>{t("settingsPage.quanterixCorporation")}</Typography>
      <Typography>{t("settingsPage.addressLine1")}</Typography>
      <Typography>{t("settingsPage.addressLine2")}</Typography>


      <Box sx={{ height: '24px' }} />

      <Box sx={{width: '24px'}}>
        <Button variant="contained" onClick={() => setShowEula(!showEula)}>
          {showEula ? t("settingsPage.hideEula") : t("settingsPage.showEula")}
        </Button>
      </Box>
      


      {showEula && (
        <Box mt={2}>
          <div dangerouslySetInnerHTML={{ __html: eulaText }} />
        </Box>
      )}
    </Stack>
  );
}
